import { Vue } from 'vue-infra';
import PortalVue from 'portal-vue';
import { withFlagProvider } from 'ld-vue';
import routes from './router/routes';
import { appName, appCode } from './common/consts';
import { loadI18nResources } from './i18n/resource-resolver';
import './styles/app.scss';


const AppComponent = r => require.ensure([], () => r(require('./App.vue')), 'AppComponent');
// fixme - add instructions for every prop
const config = {

  id: appName,

  keepDOMRendered: false, // true -> use v-show instead of v-if in the application renderer

  moduleName: appName,

  routePrefix: appCode,

  // todo - don't just pass any persona
  personaMapping: appName,

  // todo - try passing ['*']
  personas: ['agent', 'agentManager', 'admin', appName],

  switcher: {

    // fixme (LE) - provide fallback in case this is not set
    // control: `switcher-item-${appName}`,

    // fontIconName: 'ico-<something>', // icon for the navigation menu.

    // fixme (LE) - provide fallback in case this is not set
    index: 999,
    // todo - try these
    // title: appName,
    // tooltip: appName,
    // iconClass: 'ico-16 ico-switcher-item-automation-platform',
  },

  // @deprecated - will be removed in LE 10.9
  external: true,
  // @deprecated - will be removed in LE 10.9
  regionId: `${appName}-external`,
  // @deprecated - will be removed in LE 10.9
  container: 'work-area-wrapper',
  // @deprecated - will be removed in LE 10.9
  template: 'workAreaItemNoLEClass',
};

// todo - add an example implementation with permission validation from another app
const canInitialize = ({ auth = true } = {}) => {
  if (auth) {
    return true;
  }
  return false;
};

const registerAppComponent = (leAppConfig) => {
  // register the component globally to get the Vue.js dev-tools working.
  // the registration name must be the same as config.routePrefix, in order for the component to load property.
  Vue.use(PortalVue, {
    portalName: 'sm-portal',
    portalTargetName: 'sm-portal-target',
  });

  Vue.component(appCode, {
    name: appCode,
    template: '<App/>',
    mixins: [withFlagProvider(leAppConfig.config)],
    components: {
      App: AppComponent,
    },
  });
};

const applicationInit = async (leAppConfig) => {
  if (!canInitialize(leAppConfig)) {
    return {};
  }

  const i18nResources = await loadI18nResources(leAppConfig.locale, leAppConfig.fallbackLocale);

  registerAppComponent(leAppConfig);

  return {
    appId: appCode,
    routes,
    ...i18nResources,
  };
};

const webpackPathInit = (leAppConfig) => {
  __webpack_public_path__ = leAppConfig.publicPath; // eslint-disable-line
};


export default {
  config,
  // todo - rename to 'initialize'
  applicationInit,
  // todo - rename as lifecycle hook: 'on[Something]', i.e. according to the invoked LE lifecycle event.
  // todo - suggestions: onBootstrap, onAppsLoad
  webpackPathInit,
};
